export default __webpack_public_path__ + "static/media/nicole.855ab6ea.jpg";